var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25012 3.31066L1.53045 6.03033C1.23756 6.32322 0.762684 6.32322 0.469791 6.03033C0.176897 5.73744 0.176897 5.26256 0.469791 4.96967L4.46979 0.969671C4.76268 0.676777 5.23756 0.676777 5.53045 0.969671L9.53045 4.96967C9.82334 5.26256 9.82334 5.73744 9.53045 6.03033C9.23756 6.32322 8.76268 6.32322 8.46979 6.03033L5.75012 3.31066L5.75012 13C5.75012 13.4142 5.41434 13.75 5.00012 13.75C4.58591 13.75 4.25012 13.4142 4.25012 13L4.25012 3.31066Z",
    fill: "#0B74BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.e866c40b8e0056f817431888221d4e3e.svg";
export { ForwardRef as ReactComponent };